import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  sliderContainer: (withNavigation: boolean, isArticle: boolean, withoutPadding: boolean = false, equalHeightSlides: boolean = false) => ({
    position: 'relative',
    '.swiper': {
      paddingBottom: withoutPadding ? [24, 24, 20, 24, 28, 40] : withNavigation ? [80, 80, 96, 156] : 0,
      ...(equalHeightSlides ? {
        '.swiper-wrapper': {
          alignItems: 'stretch'
        },
        '.swiper-slide': {
          width: 'auto',
          height: 'auto !important',
          display: 'flex'
        },
        '.swiper-slide > div': {
          height: '100%',
          width: '100%',
          display: 'flex'
        }
      } : {
        '.swiper-slide': {
          width: 'auto'
        }
      }),
      '.swiper-scrollbar': {
        margin: [`32px 0px 48px ${isArticle ? '40px' : '24px'}`, `32px 0px 48px ${isArticle ? '40px' : '24px'}`, `32px 0px 64px ${isArticle ? '64px' : '24px'}`, '40px 10.15625vw 116px 10.15625vw'],
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: [`calc(100% - ${isArticle ? '80px' : '48px'})`, `calc(100% - ${isArticle ? '80px' : '48px'})`, `calc(100% - ${isArticle ? '128px' : '48px'})`, 'calc(100% - (10.15625vw * 2))'],
        height: '2px',
        background: '#cccccc',
        borderRadius: '1px',
        order: 99
      },
      '.swiper-scrollbar-drag': {
        backgroundColor: theme.rawColors.darkGrey700,
        cursor: 'pointer'
      },
      '.swiper-pagination': {
        padding: '32px 16px 48px',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'transparent',
        display: 'flex',
        columnGap: '4px',
        justifyContent: 'stretch',
        '.bullet-pagination': {
          backgroundColor: '#cccccc',
          height: '2px',
          width: '100%',
          ...reusables.mainTransition('background-color'),
          '&.swiper-pagination-bullet-active': {
            backgroundColor: theme.rawColors.darkGrey700
          }
        }
      }
    }
  })
};